export const tab_list = ["DELIVERY", "DEPOSIT", "PAYMENT BILL", "REJECTED ITEMS", "JOURNAL", "LOGBOOK", "OTHERS"]